import { Component, OnInit } from '@angular/core';
import { ApiService } from '../_services/api.service';
import { Category } from '../_models/category';
import { FormItem } from '../_models/formitem';
import { LanguageService } from '../_services/language.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../misc/ErrorDialogComponent';
import {FormHelperService} from "./file-online-v2/services/form-helper.service";
import {FormDetail} from "./file-online-v2/models/api/Form";

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {
  status = false;
  CategoryItems: Category[];
  forms: FormDetail[];
  searchText = "";
  currentCategory = 0;
  subscription: Subscription;
  formTitle;
  url: string = ""

  constructor(protected apiService: ApiService, private languageService: LanguageService, public router: Router, private dialog: MatDialog,
              protected formHelper: FormHelperService) {
    this.subscription = this.languageService.currentMessage.subscribe(message => {
      this.getCategories();
      this.getForms();
      this.url = apiService.baseUrl.slice(0, -4);
    })
  }

  ngOnInit() {
    // this.getCategories();
    // this.getForms();
    // console.log(this.apiService.getCategories().subscribe())
  }

  getEfileUrl(form: FormItem): string {
    return '/efile/submit?id=' + form.formNumber.replace(/\s/g, '').replace(/\//g, '-');
  }

  getCategories() {
    this.apiService.getCategories().subscribe(data => {
      console.log(data);
      this.CategoryItems = data;
     })
  }

  getForms(): void {
    this.apiService.getAllForms().subscribe(data => {
      console.log(data);
      this.forms = data;
    });
  }

  // routeToLink(form: string) {
  //   this.router.navigateByUrl('/efile/submit', { state: { url: form } });
  // }

  // Method to handle the "Submit Online" click event
  onSubmitOnline(form: any): void {
    // this.validatePing(form);
    const formIdentifier = form.formNumber.replace(/ \/ /g, '-'); // replace ' / ' with '-'
    // this.router.navigate(['/efile/submit'], {queryParams: {id: formIdentifier}}).then(r => r);
    this.router.navigateByUrl(`/efile/submit?id=${formIdentifier}`, { state: { url: form.fileUrl } }).then(r => r);
  }

  // validatePing(form: any) {
  //   //Perform the ping operation
  //
  //   this.apiService.ePing().subscribe(
  //     (data) => {
  //       if (data.status == 200) {
  //         console.log("success ping",form.fileId)
  //         // Ping Successful, navigate to the "Submit Online" page
  //         switch(form.fileId) {
  //           case 24:
  //             this.router.navigateByUrl('/efile/submit?id=7', { state: { url: form.fileUrl } });
  //             break;
  //           case 1:
  //             this.router.navigateByUrl('/efile/submit?id=1', { state: { url: form.fileUrl } });
  //             break;
  //           default:
  //             // Handle unexpected values or provide a default action
  //             break;
  //         }
  //       } else {
  //         // Ping Failed, display an error message
  //         console.log("Ping failed")
  //         this.handlePingError();
  //       }
  //     },
  //     (err) => {
  //       this.handlePingError();
  //     }
  //   );
  //
  //   // switch(form.fileId) {
  //   //   case 24:
  //   //     this.router.navigateByUrl('/efile/submit?id=7', { state: { url: form.fileUrl } });
  //   //     break;
  //   //   case 1:
  //   //     this.router.navigateByUrl('/efile/submit?id=1', { state: { url: form.fileUrl } });
  //   //     break;
  //   //   default:
  //   //     // Handle unexpected values or provide a default action
  //   //     break;
  //   // }
  // }

  handlePingError(): void {
    // Customize the error message
    const errorMessage = 'We\'re experiencing technical issues at the moment.';

    // Open the custom error dialog
    this.openErrorDialog(errorMessage);
  }

  openErrorDialog(errorMessage: string): void {
    console.log('Displaying error:', errorMessage);
    this.dialog.open(ErrorDialogComponent, {
      width: '300px', // Set the width as per your requirement
      data: { errorMessage },
    });
  }





}
